// extracted by mini-css-extract-plugin
export default {"container":"qq-z","brandName":"rq-z","productName":"sq-z","productNamePdpEnhancements":"tq-z","breakLongProductName":"uq-z"};